import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { categoriesApi } from '../../services/api';
import logger from '../../utils/logger';

const Slider = {
    breakpoints: {
         0: {
             slidesPerView: 1,
         },
         600: {
             slidesPerView: 2.5,
         },
         1000: {
             slidesPerView: 4,
         },
     },
 };
 
 function About() {
     const [niches, setNiches] = useState([]);
 
    useEffect(() => {
        async function getNiches() {
            try {
                const niches = await categoriesApi.fetchAllNiches();
                setNiches(Array.isArray(niches) ? niches : []);
            } catch (error) {
                logger.error('Error loading niches', error);
            }
        }

        getNiches();
    }, []);
    return (
        <>
            <section className="about_us_section hero">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge">Ce este LUMO</span>
                        <h2>
                            LUMO e mai mult decât o aplicație. <br/> Este <span>partenerul tău</span> digital.
                         
                        </h2>
                        <p>
                        LUMO Business este dedicat tuturor celor care oferă servicii cu programare. Creezi cont, setezi programul și începi să <br/> primești rezervări. Nu contează dacă ești parte dintr-un salon sau freelancer – dacă oferi servicii, LUMO e locul tău.
                        <br/><br/>Și dacă încă nu-ți găsești nișa în aplicație, poți fi chiar primul din domeniul tău.
                        <br/><br/><br/>
                        Categorii populare
                        </p>
                    </div>
                </div>
                <div className="about_slider row_am" data-aos="fade-in" data-aos-duration={1500}>
                    <Swiper className="mySwiper" id="about_slider" {...Slider} spaceBetween={15} slidesPerView={4}>
                        {niches.map((niche, index) => (
                            <SwiperSlide key={index} className="item">
                                <div className="abt_slides niche">
                                    <div className='d-flex flex-row justify-content-center content'>
                                    <img
                                        src={niche.image}
                                        alt={niche.name}
                                        style={{ height: "100%", width: "100%", objectFit: "fill" }}
                                    />
                                    <span className="niche-label">
                                        {niche.name}
                                    </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                {/*
                <div className="container">
                    <div className="row abt_text" data-aos="fade-up" data-aos-duration={1500}>
                        <div className="col-md-5">
                            <h2>
                            Am creat <span>LUMO</span> ca răspuns la o nevoie reală: servicii locale, <span>fără complicații</span>
                            </h2>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'justify'}}>
                            <p>
                            LUMO este construit de o echipă tânără de profesioniști care cred că lucrurile bune se pot face mai simplu, mai curat și mai digital. Am pornit cu o idee clară: România are nevoie de o platformă care să conecteze oamenii cu serviciile de zi cu zi, într-un mod modern, intuitiv și de încredere.
                            </p>
                            <p>
                            Vrem să contribuim activ la digitalizarea pieței serviciilor din România și să susținem profesioniștii locali printr-un ecosistem clar, transparent și eficient. Știm că timpul e o resursă tot mai prețioasă, iar misiunea noastră este să-l respectăm — atât pentru cei care oferă, cât și pentru cei care caută servicii.
                            </p>
                            <p>
                            Ne ghidăm după valori simple: transparență, eficiență, încredere și beneficii reale pentru ambele părți. Suntem atenți la detalii, conectați la realitate și deschiși la tot ce poate îmbunătăți experiența celor care aleg LUMO.
                            </p>
                            <p>
                            Nu ne dorim să fim doar „încă o aplicație”, ci o soluție completă, umană, adaptată stilului de viață modern.
                            </p>

                            
                        </div>
                    </div>
                </div>
                */}
            </section>
        </>
    );
}

export default About;
